import React from 'react';
import styled from 'styled-components';
import { BREAKPOINT, LFRAME_TYPE } from '@latitude/core/utils/constants';
const L = /*#__PURE__*/styled.div.withConfig({
  displayName: "Lframe__L",
  componentId: "sc-1pfyw3q-0"
})(["position:absolute;top:0;right:0;z-index:1;width:100vw;height:1237px;background-repeat:no-repeat;pointer-events:none;background-size:720px;background-position:top left 15px;@media (min-width:", "){background-position:calc(100vw - ", " - ((100vw - ", " ) / 2) + 15px ) 0;}@media (min-width:", "){background-size:992px;background-position:50vw 0;}@media (min-width:", "){background-size:1200px;}", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], BREAKPOINT.SM, BREAKPOINT.SM, BREAKPOINT.SM, BREAKPOINT.MD, BREAKPOINT.LG, props => props.home && `background-image: url(${require('./images/lframe-home.png')});
    @media (max-width: ${BREAKPOINT.MD}) {
      top: -80px;
    }
    @media (min-width: ${BREAKPOINT.MD}) {
      top: -48px;
      background-position: 50vw 24px;
    }
  `, props => props.loans && `background-image: url(${require('./images/lframe-loans.png')});`, props => props.payItFaster && `background-image: url(${require('./images/lframe-pay-it-faster.png')});`, props => props.personalLoans && `background-image: url(${require('./images/lshape-blue.svg')});`, props => props.cards && `background-image: url(${require('./images/lframe-cards.png')});`, props => props.infinity && `background-image: url(${require('./images/lshape-purple.svg')});`, props => props.cardLowRate && `background-image: url(${require('./images/lshape-light-blue.svg')});`, props => props.simple && `@media (min-width: 0) {
      max-height: 280px;
      background-position: 50vw 0;
    }`, _ref => {
  let {
    type
  } = _ref;
  if (type === LFRAME_TYPE.BLUE) {
    return `background-image: url(${require('./images/lshape-blue.svg')});`;
  }
  if (type === LFRAME_TYPE.SECONDARY_BLUE) {
    return `background-image: url(${require('./images/lshape-secondary-blue.svg')});`;
  }
  if (type === LFRAME_TYPE.LIGHT_BLUE) {
    return `background-image: url(${require('./images/lshape-light-blue.svg')});`;
  }
  if (type === LFRAME_TYPE.PURPLE) {
    return `background-image: url(${require('./images/lshape-purple.svg')});`;
  }
  return '';
}, _ref2 => {
  let {
    bgImage
  } = _ref2;
  return bgImage && `background-image: url(${bgImage});`;
});
const Lframe = props => /*#__PURE__*/React.createElement(L, props);
export default Lframe;